<template>
  <v-autocomplete
    v-model="selectedAirport"
    color="secondary"
    :items="airports"
    item-value="iata_code"
    :item-text="(item) => item.iata_code + ' - ' + item.name"
    menu-props="auto"
    :outlined="!mobile"
    filled
    :label="label"
    hide-details
    single-line
    return-object
    background-color="white"
    style="border-radius: 0 !important; z-index: 4;"
    @blur="checkForValue"
  >
    <template v-slot:append>
      <v-icon color="grey">
        fas fa-search
      </v-icon>
    </template>
    <template v-slot:selection="{ item }">
      <span>{{ item.iata_code }}</span>
    </template>
    <template v-slot:append-outer>
      <v-btn
        v-if="showButton"
        color="primary"
        class="attached-button"
        @click="selectAirport(selectedAirport)"
      >
        View Airport
      </v-btn>
    </template>
  </v-autocomplete>
</template>
<style scoped>
.mobile-menu .v-text-field--filled {
  background-color: #db3539;
}
.v-field--outlined,
.v-text-field--solo {
  border-radius: 0 !important;
}
.attached-button {
  height: 56px !important;
  margin-top: -18px;
  margin-left: -9px;
  box-shadow: none;
  border-radius: 0;
  font-size: 12px;
  min-width: 150px !important;
}
</style>
<script>
import { mapState, mapActions } from 'vuex'
import UsesSelectAirportMixins from '../../mixins/UsesSelectAirportMixins'

export default {
  name: 'AirportAutocompete',
  mixins: [UsesSelectAirportMixins],
  props: {
    emit: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    mobile: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    label: {
      type: String,
      default: null
    },
    setAirportFromStore: {
      type: Boolean,
      default: false
    },
    showButton: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  data() {
    return {
      selectedAirport: null
    }
  },
  computed: {
    ...mapState({
      airports: (state) => {
        return state.airports.airports
      }
    })
  },
  watch: {
    selectedAirport(val) {
      if (this.emit) {
        this.$emit('airportSelected', val.iata_code)
      } else {
        this.selectAirport(val)
      }
    }
  },
  created() {
    this.fetchAirports()
  },
  mounted() {
    if (this.setAirportFromStore) {
      setTimeout(() => {
        const store = this.$store.state.settings
        if (store.settings.airport.current) {
          this.selectedAirport = store.settings.airport.current
        }
      }, 100)
    }
  },
  methods: {
    ...mapActions({
      fetchAirports: 'airports/fetchAirports'
    }),
    checkForValue() {
      if (!this.selectedAirport) {
        const store = this.$store.state.settings
        if (store.settings.airport.current) {
          this.selectedAirport = store.settings.airport.current
        }
      }
    }
  }
}
</script>
